<template>
   <div :class="darkMode ? 'dark' : ''">

      <!-- Messaggio che appare se si accede da mobile e schermi md -->
      <div id="onlydesktop" class="block md:!hidden"> 
			<div v-if="loggedAs && loggedAs.ruolo=='admin'" id="onlydesktopAdmin" class=" bg-csenRed-200 p-12">
				<div class="bg-csenRed-100 text-csenRed-600 p-3 inline-flex rounded-full mb-4">
					<MobileIcon></MobileIcon>
				</div>
				<div class="bg-csenGreen-100 text-csenGreen-600 p-3 inline-flex rounded-full mb-4">
					<DesktopIcon></DesktopIcon>
				</div>
				<div><h2 class="text-left text-lg text-csenRed-800 font-bold mb-2">⛔ Accesso non consentito</h2></div>
				<p class=" text-left text-csenRed-900 text-base font-semibold">L'accesso come amministratore <strong>non è consentito da mobile</strong>. Collegati da un computer desktop per svolgere le attività come amministratore.</p> 

			</div>
		</div>

      <div id="maincontainer" class="hidden md:!block sm:px-[5%] !font-sans dark:bg-[#171a35]">
         <div class="bg-csenBlue-950 dark:bg-csenBlue-900 px-12 sm:px-24 py-12 rounded-b-md">
            <MenuTecnici @avvia-guida="avviaTour"></MenuTecnici>

            <div flat class="mt-6 bg-white px-6 py-3 rounded-md">
               <v-text-field
                  v-model="search"
                  hide-details
                  flat 
                  solo
                  light
                  class="relative w-full border-none rounded-lg"
                  prepend-icon="mdi-magnify"
                  clearable
                  placeholder="Cerca circolari"
                  clear-icon="mdi-close-circle-outline"
                  @click:clear="resetSearch()"
                  ></v-text-field>
            </div>
         </div>





         <!-- NUOVA VERSIONE -->
         <div class="mt-6 bg-csenBlue-200"> 

            <v-data-table
               id="tabella-circolari-automatiche"
               class="tabella-csen"
               :items="circolariAutomatiche"
               :loading="isLoading" 
               :search="search"
               :items-per-page="6"
               :footer-props="{
                     itemsPerPageOptions: [6, 12, 24],
                     itemsPerPageText: 'Circolari per pagina'
                  }"
               :headers="[
                  { text: 'Nome', value: 'tipo', sortable:false },
                  { text: 'Data e ora di invio della circolare', value: 'data_invio', sortable:false, width:'180px' },
                  { text: 'Anno di riferimento del rinnovo', value: 'anno_rinnovo_riferimento', sortable:false, width:'180px' },
                  { text: 'Stato della circolare', value: 'is_attiva', sortable:false,},
                  { text: 'Modello Email', value: 'modello_email.nome', sortable:false, width:'300px'},
                  { text: 'Azioni', value: 'azioni', sortable:false, class: 'text-end'}
               ]"
            >

            <!-- TIPO -->
            <template v-slot:item.tipo="{ item }">
               <div class="d-flex gap-1 font-medium">
                  {{conversioneTipoCircolare(item.tipo)}}
               </div>
            </template>

            <!-- DATA E ORA INVIO -->
            <template v-slot:item.data_invio="{ item }">
               <div class="riga-circolare-automatica d-flex gap-1">
                  <!-- Controllo per 'conferma_rinnovo_auto' -->
                  <span v-if="item.tipo === 'conferma_rinnovo_auto'" class="py-2 text-gray-900 dark:text-gray-300 text-xs">
                     Inviato appena viene confermato un pagamento automatico
                  </span>
                  
                  <!-- Controllo per 'conferma_rinnovo_manuale' -->
                  <span v-else-if="item.tipo === 'conferma_rinnovo_manuale'" class="py-2 text-gray-900 dark:text-gray-300 text-xs">
                     Inviato appena viene inserito un pagamento manuale
                  </span>

                  <!-- Controllo se la data è futura -->
                  <!-- new Date(item.data_invio) < new Date() -->
                  <v-tooltip v-else bottom>
                     <template v-slot:activator="{ on, attrs }">
                     <span
                        v-bind="attrs"
                        v-on="on"
                        :class="{'!text-csenOrange-500': item.is_inviata == 1}"
                        class="font-semibold"
                     >
                        {{ formattaDatatime(item.data_invio) }}
                     </span>
                     </template>
                     <span v-if="item.is_inviata == 1">La data impostata per l'invio è precedente alla data odierna</span>
                     <span v-else-if="item.is_inviata == 0">Questa circolare non è stata ancora inviata</span>
                  </v-tooltip>
               </div>
            </template>

            <template v-slot:item.anno_rinnovo_riferimento="{ item }">
               <span class="">{{ item.anno_rinnovo_riferimento }}</span>
               <v-tooltip v-if="!item.modello_email.has_anno_riferimento" bottom>
                  <template v-slot:activator="{ on, attrs }">
                     <v-icon v-bind="attrs" v-on="on" color="red" class="ml-2">
                        mdi-alert-circle
                     </v-icon>
                  </template>
                  <span>Attenzione: il modello email selezionato non riporta l'anno di riferimento del rinnovo</span>
               </v-tooltip>
            </template>


            <!-- STATO DELLA CIRCOLARE-->
            <template v-slot:item.is_attiva="{ item }">
               <div class="d-flex gap-1">
                  <span class="inline-flex gap-x-1 py-1.5 px-2 text-xs font-medium text-csenBlue-500 dark:text-white bg-csenBlue-100 dark:bg-csenBlue-500 rounded-full" v-if="item.tipo.startsWith('conferma_rinnovo_')">Sempre Attiva</span>
                  <span class="inline-flex gap-x-1 py-1.5 px-2 text-xs font-medium text-csenOrange-500 dark:text-white bg-csenOrange-100 dark:bg-csenOrange-500 rounded-full" v-else-if="item.is_attiva == 0">Non attiva</span>
                  <span class="inline-flex gap-x-1 py-1.5 px-2 text-xs font-medium text-csenGreen-500 dark:text-white bg-csenGreen-100 dark:bg-csenGreen-500 rounded-full" v-else>Attiva</span>
               </div>
            </template>

            <!-- MODELLO -->
            <template v-slot:modello_email.nome="{ item }">
              <span class="!text-red-500">
                {{ item.modello_email.nome }}
              </span>
            </template>


				<!-- AZIONI TABELLA -->
				<template v-slot:item.azioni="{ item }">
						 <div class="d-flex justify-end gap-1">
							<v-tooltip bottom :max-width="250">
                        <template v-slot:activator="{ on, attrs }">
                           <button
                              id="tooltip"
                              type="button"
                              v-bind="attrs"
                              v-on="on"
                              class="bg-csenBlue-50 !cursor-default dark:bg-csenBlue-500 !text-csenBlue-500 dark:!text-white hover:dark:!brightness-125 p-1 rounded-md hover:bg-csenBlue-500 hover:!text-white transition" 
                           >
                              <InfoIcon class="info-voce-circolari-automatiche !w-5 !h-5"></InfoIcon>
                           </button>
                        </template>
                           <span > 
                              <span  v-if="item.tipo === 'reminder_1'">Quando attiva, questa circolare invia un'email ai tecnici che non hanno ancora rinnovato, ricordando di farlo prima della scadenza. Naturalmente, la data di invio deve essere precedente alla data di scadenza dei rinnovi dell’anno corrente.</span>
                              <span v-else-if="item.tipo === 'reminder_2'">Se attiva, questa circolare ricorda ai tecnici che non hanno ancora rinnovato, di farlo prima della scadenza. Serve come secondo reminder, dopo aver inviato la circolare “1° Promemoria Rinnovo”. Assicurati che la data di invio sia successiva alla circolare “1° Promemoria Rinnovo” e precedente alla data di scadenza dei rinnovi dell’anno corrente.</span>
                              <span v-else-if="item.tipo === 'sollecito_1'">Quando attiva, questa circolare invia un'email ai tecnici che non hanno ancora rinnovato, ricordando di farlo anche se è passata la scadenza dei rinnovi dell’anno corrente. Naturalmente, la data di invio deve essere successiva alla data di scadenza dei rinnovi dell’anno corrente.</span>
                              <span v-else-if="item.tipo === 'sollecito_2'">Se attiva, questa circolare invia un'email ai tecnici che non hanno ancora rinnovato, ricordando loro di farlo anche se è passata la scadenza. Serve come secondo reminder, dopo aver inviato la circolare “1° Sollecito Rinnovo”. Assicurati che la data di invio sia successiva alla circolare “1° Sollecito Rinnovo”</span>
                              <span v-else-if="item.tipo === 'conferma_rinnovo_auto'">Questa circolare viene inviata automaticamente ai tecnici quando acquistano il rinnovo del patentino tramite pagamento digitale.</span>
                              <span v-else-if="item.tipo === 'conferma_rinnovo_manuale'">Questa circolare viene inviata automaticamente ai tecnici quando il rinnovo del patentino viene effettuato manualmente dell'amministrazione CSEN Corsi.</span>
                           </span>
                        </v-tooltip>

							<button
								type="button"
								@click="openCircolariDialog(item)"
								class="modifica-circolare-automatica bg-csenOrange-100 dark:bg-csenOrange-500 !text-csenOrange-500 dark:!text-white hover:dark:!brightness-125 p-1 rounded-md hover:bg-csenOrange-500 hover:!text-white transition" 
								title="Modifica"
							>
							   <EditIcon></EditIcon>
							</button>
							
						 </div>
				 
				</template>



            </v-data-table>


         </div>

         <!-- DIALOG CIRCOLARE -->
        <template>
            <v-dialog v-model="circolariDialog" width="1200px" persistent>
                <!-- @click:outside="closeCircolariDialog" -->
                <v-card plain class="dark:!bg-csenBlue-900" >
                    <v-card-title class="font-bold text-2xl py-6 pl-8 dark:!bg-csenBlue-800 border-b border-b-gray-200 dark:border-none">
                        <span class="flex-grow">
                            <h2>
                                Modifica: <span class="text-csenBlue-700 dark:text-csenBlue-200">{{ conversioneTipoCircolare(circolareInModifica.tipo) }}</span>
                            </h2>
                        </span>
                        <v-btn class="!text-gray-900 dark:!text-csenBlue-200" icon @click="closeCircolariDialog">
                            <CloseIcon />
                        </v-btn>
                     </v-card-title>
                     <v-card-text class="!m-0 !p-0">
                        <v-form ref="formCircolare">
                           <div class="my-5 mx-8">
                              <div v-if="!circolareInModifica.tipo.startsWith('conferma_rinnovo_')" class="container mx-auto px-4">
                                 <div class="flex ">
                                       <!-- GIORNO -->
                                       <div class="w-full px-4 sm:w-1/3">
                                          <v-text-field
                                             v-model="dataCircolareInModifica"
                                             label="Imposta la data di invio della circolare"
                                             type="date"
                                             outlined
                                             :rules="[rules.required]"
                                             @input="circolareModificata = true"
                                          ></v-text-field>
                                       </div>

                                       <!-- ORA  -->
                                       <div class="w-full px-4 sm:w-1/3">
                                          <v-text-field
                                             v-model="oraCircolareInModifica"
                                             label="Imposta l'ora di invio della circolare"
                                             outlined
                                             :rules="[ 
                                                   rules.required,
                                                   (v) => !!v || 'Imposta ora di invio della circolare', 
                                                   (v) => /^([01]\d|2[0-3]):([0-5]\d)$/.test(v) || 'Formato ora non valido (HH:mm)' 
                                             ]"
                                             hint="Formato HH:mm"
                                             @input="circolareModificata = true"
                                          ></v-text-field>
                                       </div>

                                       <!-- ANNO -->
                                       <div class="w-full sm:w-1/3 px-4">
                                          <v-select
                                             v-model="circolareInModifica.anno_rinnovo_riferimento"
                                             :items="anniDisponibili"
                                             label="Seleziona l'anno di riferimento del rinnovo"
                                             outlined
                                             :rules="[rules.required]"
                                             @change="circolareModificata = true"
                                          >

                                             <template v-slot:append>
                                                <v-tooltip v-if="!modelloEmailSelezionatoHasRiferimentoRinnovo" bottom>
                                                   <template v-slot:activator="{ on, attrs }">
                                                      <v-icon v-bind="attrs" v-on="on" color="red" class="ml-2">
                                                         mdi-alert-circle
                                                      </v-icon>
                                                   </template>
                                                   <span>Attenzione: il modello email selezionato non riporta l'anno di riferimento del rinnovo</span>
                                                </v-tooltip>
                                             </template>
                                       
                                          </v-select>
                                       </div>
                                 </div>
                              </div>
                              <v-divider v-if="!circolareInModifica.tipo.startsWith('conferma_rinnovo_')"></v-divider>
                              
                              <!-- ATTIVA -->
                              <div v-if="!circolareInModifica.tipo.startsWith('conferma_rinnovo_')" class="mx-8 flex justify-between">
                                 <div class="my-auto text-lg font-semibold text-csenBlue-950 dark:text-white"> Non attivo / Attivo </div>
                                 <div>
                                       <v-switch
                                          v-model="circolareInModifica.is_attiva"
                                          color="primary"
                                          class="pointer"
                                          @change="circolareModificata = true"
                                       ></v-switch>
                                 </div>
                              </div>
                              <v-divider v-if="!circolareInModifica.tipo.startsWith('conferma_rinnovo_')"></v-divider>

                              <!-- Componente Modello Email -->
                              <div class="mt-12">
                                 <v-autocomplete
                                    label="Seleziona un modello email"
                                    autocomplete="none"
                                    v-model="circolareInModifica.modello_email_id"
                                    :items="modelliEmailDisponibili"
                                    item-value="id"
                                    item-text="nome"
                                    outlined 
                                    clearable
                                    :rules="[rules.required]"
                                    @change="circolareModificata = true"
                                 ></v-autocomplete>
                                    <span class="!font-sans text-lg text-csenBlue-950 dark:text-csenBlue-100 mb-6 pt-3 font-semibold" v-if="circolareInModifica.modello_email_id">🔍 La seguente è un'anteprima dell'email che verrà utilizzata:</span><br/>
                                 <ModelloEmailComponent 
                                    v-if="circolareInModifica.modello_email_id" 
                                    :id="circolareInModifica.modello_email_id" 
                                    :only-view="true">
                                 </ModelloEmailComponent>
                              </div>

                           </div>
                        </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="p-4 justify-end !bg-gray-200 dark:!bg-csenBlue-800 sticky bottom-0 z-40">
                        <v-btn class="!bg-white!tracking-wider !py-5 !px-5" text @click="closeCircolariDialog">Annulla</v-btn>
                        <v-btn class="!bg-csenBlue-900 dark:!bg-csenGreen-500 !text-white !tracking-wider !py-5 !px-5" text @click="modificaCircolare()">Salva modifiche</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>


         <!-- Qui c'era la vecchia versione -->

            <!-- LOGOUT -->
            <div class="block sm:flex gap-2 !justify-start border-t border-t-gray-300 dark:border-t-csenBlue-300 pt-4 mt-3">
            <template>
               <v-btn v-if="loggedAs && loggedAs.ruolo && loggedAs.ruolo.length > 0" class=" !block !mb-2 sm:!inline sm:!mb-0 !tracking-normal !bg-slate-200 !text-slate-600 dark:!text-white dark:!bg-csenBlue-800" @click="logout">
                  <v-icon left>mdi-logout</v-icon>
                  Logout
               </v-btn>
            </template>
            </div>

		  <!-- TO TOP -->
        <div 
               class="flex fixed justify-end items-end bottom-6 md:bottom-5 right-6 md:right-5 bg-csenBlue-800 rounded-full px-2 py-2 !z-[60] cursor-pointer hover:bg-csenOrange-500 transition" 
               @click="scrollToTop"
			   title="Torna in cima"
            ><div><ChevronUpIcon></ChevronUpIcon></div>
            </div>

         <!-- FOOTER -->
         <div>
            <FooterComponent></FooterComponent>
         </div>
         <!-- FINE FOOTER -->      
      </div>

      <v-tour name="myTourCircolariAutomatiche" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>

      <!-- Overlay per bloccare i click durante il tour -->
      <div v-if="tourAvviato" class="tour-overlay"></div>
   </div>
</template>



<script>
   import MenuTecnici from '../components/MenuTecnici.vue';
   import CardCircolareAutomatica from '../components/CardCircolareAutomatica.vue';

   import mixin from '../mixin';
   import store from '../store';

   const circolariInModificaOrigin = {
      "id": null,
      "modello_email_id": null,
      "data_invio": null,
      "tipo": '',
      "anno_rinnovo_riferimento": null,
      "is_attiva": 0
   }

   export default {
      components: {
         MenuTecnici
      },
      mixins: [mixin],
      data() {
         return {
            isActive: true, // Imposta il valore iniziale su true

            isLoading: false,
            circolariAutomatiche: [],

            datiModelloEmailAperto: {},
            modelloEmailDialog: false,

            circolariDialog: false,
            formCircolare: null,
            circolareInModifica: {
               ...circolariInModificaOrigin
            },
            oraCircolareInModifica: null, // Poi confluirà in circolareInModifica.data_invio
            dataCircolareInModifica: null, // Poi confluirà in circolareInModifica.data_invio
            circolareModificata: false,
            anniDisponibili: this.ottieniUltimiAnniPiuUno(), // Anni disponibili per inviare le circolari di reminder e solleciti
            modelliEmailDisponibili: [],
            modelloEmailSelezionatoHasRiferimentoRinnovo: false, // Indica se il modello email selezionato ha un riferimento al rinnovo

            search: null,

            tourAvviato: false,
				tourCallbacks: {
					onFinish: this.fineTour,
					onSkip: this.fineTour,
					onStop: this.fineTour,
				},
            tourSteps: [
               {
                  target: '#menu-circolari-automatiche-tab',
                  content: `
                     Benvenuto nella pagina dedicata alle Circolari Automatiche
                  `
               },
               {
                  target: '#tabella-circolari-automatiche',
                  content: `
                     Qui trovi le 6 Circolari Automatiche che puoi modificare, personalizzare e programmare per l'invio.
                  `
               },
               {
                  target: '.info-voce-circolari-automatiche',
                  content: `
                     Passa con il mouse sopra questa icona per capire a cosa serve ognuna di queste circolari.
                  `
               },
               {
                  target: '.modifica-circolare-automatica',
                  content: `
                     Cliccando su “Modifica” puoi modificarne alcuni parametri come: data e ora dell'invio e il modello email da utilizzare.
                  `
               },
               {
                  target: '.riga-circolare-automatica',
                  content: `
                     Nella riga è invece presente un'anteprima dei parametri impostati nella circolare.<br/><br/>
                     Grazie per aver seguito la guida di questa sezione.<br/><br/>
                     Saluti sportivi!
                  `
               }
            ]
         };
      },
      watch: {
         'circolareInModifica.modello_email_id'(){
            this.aggiornaModelloEmailSelezionatoHasRiferimentoRinnovo();
         }
      },
      created(){
         this.getCircolariAutomatiche();
         this.getModelliEmail((data)=>{
            this.modelliEmailDisponibili = data;
         });
      },
      mounted(){
         if(!this.isGuidaCompleta('is_guida_circolari_automatiche_completa')){
            this.tourAvviato = true;
            this.$tours['myTourCircolariAutomatiche'].start();
            this.setGuidaCompleta('is_guida_circolari_automatiche_completa');
         }
      },
      methods: {
         // init(datiIniziali){
         //    this.circolareModificata = false;

         //    if(Object.keys(datiIniziali).length > 0 && datiIniziali.data_invio != null){
         //       this.dataPrevistaGestita = datiIniziali.data_invio.split(" ")[0]
         //       // this.oraPrevistaGestita = this.dati.data_invio.split(" ")[1] // Non deve mostrare i secondi

         //       const dataOggetto = new Date(datiIniziali.data_invio);
         //       const ore = dataOggetto.getHours().toString().padStart(2, '0');
         //       const minuti = dataOggetto.getMinutes().toString().padStart(2, '0');
         //       this.oraPrevistaGestita = `${ore}:${minuti}`
         //    }
         // },

         aggiornaModelloEmailSelezionatoHasRiferimentoRinnovo(){
            let res = false;
            this.modelliEmailDisponibili.some(modelloEmail => {
               if(modelloEmail.id == this.circolareInModifica.modello_email_id){
                  res = modelloEmail.has_anno_riferimento;
                  return true; // Per interrompere il some
               }
            });
            this.modelloEmailSelezionatoHasRiferimentoRinnovo = res;
         },
         
         resetCircolareInModifica(){
            this.circolareInModifica = JSON.parse(JSON.stringify(circolariInModificaOrigin));
            this.circolareModificata = false;

            try {
               this.$refs['formCircolare'].resetValidation();
            } catch (error) {}
         },
         avviaTour(){
            this.tourAvviato = true;
            this.$tours['myTourCircolariAutomatiche'].start();
         },
         fineTour(){
            this.tourAvviato = false;
         },
         getCircolariAutomatiche(){
            this.isLoading = true;

                axios.get(`/circolari_automatiche`)
                   .then(res => {
                  this.circolariAutomatiche = res.data
               })
               .finally(() => {
                  this.isLoading = false;
               })
         },
         // openModelloDialog(dati) {
         //    console.log(dati)
         //    this.datiModelloEmailAperto = {
         //    id: null,
         //    nome: dati.nome_modello,
         //    oggetto: dati.oggetto,
         //    corpo: dati.corpo,
         //    anteprima: dati.anteprima,
         //    rispondi_a: dati.rispondi_a
         //    }

         //    this.modelloEmailDialog = true;
         // },
         // closeModelloDialog() {
         //    this.datiModelloEmailAperto = null;
         //    this.modelloEmailDialog = false;
         // },
         openCircolariDialog(item) {
            this.circolareInModifica = JSON.parse(JSON.stringify(item));

            this.aggiornaModelloEmailSelezionatoHasRiferimentoRinnovo();

            if(!item.tipo.startsWith('conferma_rinnovo_')){
               // Divido ore e minuti nei due campi:
               this.dataCircolareInModifica = this.circolareInModifica.data_invio.split(" ")[0]
   
               const dataOggetto = new Date(this.circolareInModifica.data_invio);
               const ore = dataOggetto.getHours().toString().padStart(2, '0');
               const minuti = dataOggetto.getMinutes().toString().padStart(2, '0');
               this.oraCircolareInModifica = `${ore}:${minuti}`
            }

            this.circolariDialog = true; 
         },
         closeCircolariDialog(daConfermare = true){
            if(this.circolareModificata && daConfermare){
               store.commit('mostraDialogConferma', 
                  {
                     titolo: 'Esci senza salvare le modifiche',
                     testo:'Sono presenti delle modifiche, vuoi uscire senza salvarle?', 
                     onConferma:()=>{
                        this.circolariDialog = false;
                        this.resetCircolareInModifica();
                        store.commit('nascondiDialogConferma');
                     }, 
                     onAnnulla:()=>{
                        store.commit('nascondiDialogConferma');
                     }
                  }
               );
            } else {
               this.circolariDialog = false;
               this.resetCircolareInModifica();
            }
         },
         modificaCircolare(){
            if(!this.$refs['formCircolare'].validate()){
               store.commit('mostraSnack', {messaggio: 'Alcuni campi obbligatori non sono compilati correttamente', tipo: 'error'})
               return
            }
                
            this.circolareInModifica.data_invio = this.dataCircolareInModifica + " " + this.oraCircolareInModifica

            axios.patch(`circolari/${this.circolareInModifica.id}`, this.circolareInModifica)
               .then(res => {
                  store.commit('mostraSnack', {messaggio: 'Circolare automatica modificata con successo', tipo: 'success'})
                  // this.$emit('modello-email-modificato');
                  // this.$emit('circolare-modificata');
                  this.closeCircolariDialog(false);
                  this.getCircolariAutomatiche()
               })
         }
      }
   }
</script>
















<style lang="scss" scoped>

.tabella-csen {
   background-color: #fff; 
   ::v-deep .v-data-table__wrapper th {
      color: #27316e !important;
      font-size:15px !important;
      background-color: #eef5ff;
      padding: 1rem;
   }
};

.dark {
   ::v-deep .v-data-table__wrapper th {
      color: #c7dcfe !important;
      font-size:15px !important;
      padding: 1rem;
   }
};

</style>
